import BodyMounter from '../libs/BodyMounter';
import UIFlashManager from './UIFlashManager.vue';
import { ref, Ref } from '@vue/composition-api';
import nanoid from 'nanoid';
import {
  TFlashItemOptions,
  TFlashItem,
} from '../types';

export function mountFlashManager () {
  const items: Ref<TFlashItem[]> = ref([]);
  const mounter = new BodyMounter();
  const vm = mounter.mount(h => {
    return h(UIFlashManager, {
      ref: 'flashmanager',
      props: {
        items: items.value,
      },
      on: {
        next () {
          if (items.value.length) items.value.shift();
        },
      },
    });
  });
  return vm.$refs.flashmanager as any;
}
class FlashManager {
  vm: any;
  constructor () {
    this.vm = mountFlashManager();
  }

  push (itemOptions: TFlashItemOptions) {
    const id: string = nanoid();
    const item: TFlashItem = { id, ...itemOptions };
    this.vm.items.push(item);
  }
}

let flashManager: FlashManager;
export default function useFlashService () {
  if (!flashManager) {
    flashManager = new FlashManager();
  }
  return {
    showFlash (opts: TFlashItemOptions) { flashManager.push(opts); },
  };
};
